import React from 'react'

import { useMediaQueries } from 'hooks'

import { features } from 'helpers/features'
import { multilineTrim } from 'helpers/string'

import { Typo } from 'components/_old/Typo/Typo'

import { Typography } from 'components/atoms/Typography'

const FooterInfo = (): React.ReactElement => {
  const mediaQueries = useMediaQueries()
  const { desktop } = mediaQueries

  return (
    <Typography size={desktop ? 14 : 12} color="minor">
      <Typo multiline>
        {features.get('new-questionnaire')
          ? multilineTrim(`
            The projections shown above are for illustrative purposes only and are not a reliable indicator of future performance. They are generated based on the inputs you have selected, including your risk profile, initial investment amount and any top-ups. All returns are displayed gross of fees, which will reduce the net return you ultimately receive.

            The value of investments may fall as well as rise, and you may receive back less than you originally invested. Please ensure you read the relevant product documentation for a full description of the risks, charges and terms that apply.
          `)
          : 'The chart should only be used as an indication of the range of potential outcomes based on the portfolio allocation you selected above, as well as the initial and monthly investments and time horizon. The information provided does not constitute advice or a promise of future outcomes. InvestEngine’s optimal portfolio is based only on the information you have provided as part of the risk questionnaire. If you hold your portfolio within our SIPP account you should consider the effects of tax relief and accounts fees which are not included in these projections.'}
      </Typo>
    </Typography>
  )
}

export { FooterInfo }
